import { MarkersVisualArgs } from "@progress/kendo-react-charts";
import { Circle, geometry, Group, Path } from "@progress/kendo-drawing";
import { PORTFOLIO_COLOR } from "@iliotech/data-wire";

export function RiskVsReturnMarkerRenderer(e: MarkersVisualArgs) {
  const category = e.dataItem.category.toLowerCase();
  const group = new Group();

  let shape;
  let shapeColor = e.dataItem.color; // Default color

  if (category === "portfolio") {
    const circleRadius = 10; // Bigger circle for portfolio
    shapeColor = PORTFOLIO_COLOR; // Blue color for portfolio
    shape = new Circle(new geometry.Circle(e.rect.center(), circleRadius), {
      fill: { color: shapeColor },
      stroke: { color: shapeColor, width: 1 },
    });
  } else if (category === "benchmark") {
    const diamondSize = 10; // Adjust this value to change the diamond size
    shape = new Path({
      fill: { color: shapeColor },
      stroke: { color: shapeColor, width: 1 },
    });

    shape
      .moveTo(e.rect.center().x, e.rect.center().y - diamondSize)
      .lineTo(e.rect.center().x + diamondSize, e.rect.center().y)
      .lineTo(e.rect.center().x, e.rect.center().y + diamondSize)
      .lineTo(e.rect.center().x - diamondSize, e.rect.center().y)
      .close();
  } else {
    const circleRadius = 6; // Default size for other categories
    shape = new Circle(new geometry.Circle(e.rect.center(), circleRadius), {
      fill: { color: shapeColor },
      stroke: { color: shapeColor, width: 1 },
    });
  }

  group.append(shape);
  return group;
}
